<template>
  <TsBaseProCardLayout>
    <template #proCardForm>
      <TsLoadingCircularSpinner
        v-if="procardStore.loading.application_status"
      />

      <div v-else-if="procardStore.application_status === 'active'">
        <TsThankyou
          :title="useTranslation('Procard-applicationAlreadySubmitted' ,'Jouw aanvraag is al ontvangen.')"
          :para="useTranslation('Procard-youWillRecieveResponse' ,'Binnen 5 werkdagen ontvang je van ons een reactie.')"
        />
        <TsRow is-centered append-class="my-5">
          <TsButton :label="goBacktoAccount" link="/account/pro-card" />
        </TsRow>
      </div>

      <div v-else-if="
      (applicationType === ProCardApplicationType.WITH_CREDIT && authStore.user.account_type === 'Pro Card') ||
       (applicationType === ProCardApplicationType.WITHOUT_CREDIT &&
      (authStore.user.account_type === 'Pro Card Zero' || authStore.user.account_type === 'Pro Card'))">
        <TsThankyou :title="useTranslation('applicationAlreadySubmitted' , 'Uw aanvraag is al ingediend.')" para=""/>
        <TsRow is-centered append-class="my-5" v-if="authStore?.user?.account_type === 'Pro Card'">
          <TsButton :label="useTranslation('goBacktoAccount' , 'Ga terug naar mijn account')" link="/account/pro-card" />
        </TsRow>
      </div>

      <div v-else>
        <TsMultiStepFormProCard :application-type="applicationType" />
      </div>
    </template>
  </TsBaseProCardLayout>
</template>

<script setup lang="ts">
import { ProCardApplicationType } from "~/types/ecom/procard.type";
import { useTranslation } from "~/composables/useTranslation";

const TsBaseProCardLayout = defineAsyncComponent(() => import('~/components/organisms/TsBaseProCardLayout.vue'));
const TsLoadingCircularSpinner = defineAsyncComponent(() => import('~/components/organisms/TsLoadingCircularSpinner.vue'));
const TsThankyou = defineAsyncComponent(() => import('~/components/organisms/TsThankyou.vue'));
const TsMultiStepFormProCard = defineAsyncComponent(() => import('~/components/procard/TsMultiStepFormProCard.vue'));

const authStore = useAuthStore();
const procardStore = useProCardStoreV2();
const goBacktoAccount = useTranslation("goBacktoAccount" , "Ga terug naar mijn account");

definePageMeta({
  layout: "checkout",
  middleware: ["is-logged-in"],
});

const route = useRoute("pro-card-application-type___nl-NL___default");

// @todo: check if needs to be stored in a store state
const applicationType = computed(() =>
  route.params.type?.includes("zero-account")
    ? ProCardApplicationType.WITHOUT_CREDIT
    : ProCardApplicationType.WITH_CREDIT
);

// Retrieve current application status
procardStore.loading.application_status = true;
onMounted(async () => {
  await procardStore.fetchApplicationStatus();
  procardStore.loading.application_status = false;
});
</script>
